<template>
	<div class="blockItem">
		<div class="blockBody">
			<div class="blockTitle">
				<div class="blockTitleL">学生考勤情况</div>
				<!-- <div class="blockTitleR">66666</div> -->
			</div>
			<div class="blockContent">
				<div class="title">今日出勤人数</div>
				<div class="cards">
					<div class="attendNum" v-for="(item,index) in '91,382'" :key="index">
						<span class="num" v-if="item!=','">{{item}}</span>
						<span class="comma" v-else>{{item}}</span>
					</div>
				</div>
				<div class="states">
					<div class="stateItem">
						<div class="stateTitle" :style="{color: currentState === '迟到' ? '#F8B65E' : '#FFFFFF'}">
							迟到<label class="add"><i class="iconfont icon-triangle"></i>2</label>
						</div>
						<div class="num">7</div>
					</div>
					<div class="stateItem">
						<div class="stateTitle" :style="{color: currentState === '早退' ? '#FC9C56' : '#FFFFFF'}">
							早退<label class="cut"><i class="iconfont icon-triangle"></i>0</label>
						</div>
						<div class="num">2</div>
					</div>
					<div class="stateItem">
						<div class="stateTitle" :style="{color: currentState === '请假' ? '#4FA5FC' : '#FFFFFF'}">
							请假<label class="cut"><i class="iconfont icon-triangle"></i>38</label>
						</div class="stateTitle">
						<div class="num">10</div>
					</div>
					<div class="stateItem">
						<div class="stateTitle" :style="{color: currentState === '缺勤' ? '#FA8282' : '#FFFFFF'}">
							缺勤<label class="cut"><i class="iconfont icon-triangle"></i>0</label>
						</div>
						<div class="num">148</div>
					</div>
				</div>
				<dv-charts class="echarts" :option="option" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				option1: {
					title: {
						show: false,
					},
					legend: {
						top: 46,
						right: 20,
						textStyle: {
							fontFamily: 'Arial',
							fontSize: 16,
							fill: '#FFFFFF'
						},
						// data: ['迟到', '早退', '请假', '缺勤']
						data: [
							{
								name: '迟到',
								color: 'rgba(248, 168, 94, 1)'
							}
						]
					},
					xAxis: {
						data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
					},
					yAxis: {
						data: 'value',
						max: 5000,
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [{
							name: '迟到',
							data: [1200, 2230, 1900, 2000, 3500, 4200, 4800],
							type: 'line',
							// stack: 'a',
							fill: {
								show: true
							},
							lineStyle: {
								stroke: 'rgba(248, 168, 94, 1)'
							},
							lineArea: {
								show: true,
								gradient: ['rgba(248, 168, 94, 0.8)', 'rgba(248, 168, 94, 0.2)']
							}
						}
					]
				},
				option2: {
					title: {
						show: false,
					},
					legend: {
						top: 46,
						right: 20,
						textStyle: {
							fontFamily: 'Arial',
							fontSize: 16,
							fill: '#FFFFFF'
						},
						// data: ['迟到', '早退', '请假', '缺勤']
						data: [
							{
								name: '早退',
								color: 'rgba(252, 156, 86, 1)'
							}
						]
					},
					xAxis: {
						data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
					},
					yAxis: {
						data: 'value',
						max: 5000,
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [
						{
							name: '早退',
							data: [1000, 1300, 2300, 2100, 3500, 4200, 3200],
							type: 'line',
							// stack: 'a',
							// smooth: true,
							lineStyle: {
								stroke: 'rgba(252, 156, 86, 1)'
							},
							lineArea: {
								show: true,
								gradient: ['rgba(252, 156, 86, 0.8)', 'rgba(252, 156, 86, 0.2)']
							}
						}
					]
				},
				option3: {
					title: {
						show: false,
					},
					legend: {
						top: 46,
						right: 20,
						textStyle: {
							fontFamily: 'Arial',
							fontSize: 16,
							fill: '#FFFFFF'
						},
						// data: ['迟到', '早退', '请假', '缺勤']
						data: [
							{
								name: '请假',
								color: 'rgba(79, 165, 252, 1)'
							}
						]
					},
					xAxis: {
						data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
					},
					yAxis: {
						data: 'value',
						max: 5000,
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [
						{
							name: '请假',
							data: [3000, 2210, 2300, 3200, 2000, 3000, 4000],
							type: 'line',
							// stack: 'a',
							lineStyle: {
								stroke: 'rgba(79, 165, 252, 1)'
							},
							lineArea: {
								show: true,
								gradient: ['rgba(79, 165, 252, 0.8)', 'rgba(79, 165, 252, 0.2)']
							}
						}
					]
				},
				option4: {
					title: {
						show: false,
					},
					legend: {
						top: 46,
						right: 20,
						textStyle: {
							fontFamily: 'Arial',
							fontSize: 16,
							fill: '#FFFFFF'
						},
						// data: ['迟到', '早退', '请假', '缺勤']
						data: [
							{
								name: '缺勤',
								color: 'rgba(250, 130, 130, 1)'
							}
						]
					},
					xAxis: {
						data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
					},
					yAxis: {
						data: 'value',
						max: 5000,
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [
						{
							name: '缺勤',
							data: [4000, 2210, 4000, 3200, 4000, 2000, 3000],
							type: 'line',
							// stack: 'a',
							lineStyle: {
								stroke: 'rgba(250, 130, 130, 1)'
							},
							lineArea: {
								show: true,
								gradient: ['rgba(250, 130, 130, 0.8)', 'rgba(250, 130, 130, 0.2)']
							}
						}
					]
				},
				option: {},
				currentState: '迟到'
			}
		},
		mounted() {
			this.option = this.option1
			let num = 0;
			setInterval(()=>{
				num++;
				let time = num%4;
				if(time===3) {
					this.option = this.option4
					this.currentState = '缺勤'
				} else if(time===2) {
					this.option = this.option3
					this.currentState = '请假'
				} else if(time===1) {
					this.option = this.option2
					this.currentState = '早退'
				} else {
					this.option = this.option1
					this.currentState = '迟到'
				}
			},5000)
		}
	}
</script>

<style lang="less" scoped>
	.title {
		font-size: 17px;
		text-align: center;
	}

	.cards {
		display: flex;
		justify-content: center;

		.attendNum {
			font-size: 36px;
			margin: 16px 10px;

			.num {
				display: inline-block;
				background-color: #009de7;
				padding: 2px 6px;
				border-radius: 2px;
			}

			.comma {
				display: inline-block;
			}
		}
	}

	.states {
		padding: 0 64px;
		display: flex;
		justify-content: space-around;
		align-items: center;

		.stateItem {
			text-align: center;

			.stateTitle {
				margin-bottom: 6px;
				font-size: 16px;

				label {
					font-size: 14px;

					i {
						display: inline-block;
						font-size: 18px;
					}

					&.add {
						color: #f45d5d;
					}

					&.cut {
						color: #4ad569;

						.icon-triangle {
							transform: rotate(180deg);
						}
					}
				}
			}

			.num {
				font-size: 24px;
			}
		}
	}
	.echarts {
		margin-top: -30px;
		height: calc(100% - 116px);
		width: 100%;
	}
</style>
